module.exports = __webpack_public_path__ + "static/img/cabinet12_10.1bb6f931.gif";